import { gql } from "@apollo/client";

export const CREATE_SADDLE_VARIANT = gql`
mutation createSaddleFitVariant($input: CreateSaddleFitVariantInput!) {
  createSaddleFitVariant(input: $input) {
    brandName
    createdAt
    description
    discipline
    discount
    gallery
    newOrUsed
    photo
    pk
    price
    productTitle
    quantity
    saddlefitSku
    scannedFiles
    score
    size
    sk
    status
    type
    updatedAt
    userId
    variantId
    measurements {
      barAngle
      gulletHeight
      gulletWidth
    }
    manufacturerMeasurements {
      barAngle
      gulletHeight
      gulletWidth
    }
  }
}`